import reducer from "./reducer";
export { default as PeriodsForObjectives } from "./components/index";
export { default as periodsForObjectivesReducerName } from "./constants";
export default reducer;
